module.exports = __webpack_public_path__ + "img/hannah-ourteam-banner.9340ab83.png";